import { gql } from '@apollo/client';

export const LIST_USERS = gql`
  query ListUser($search: SearchUserInput!) {
    listUser(search: $search) {
      docs {
        _id
        fullName
        email
        phone
        phonecode
        country
        pin
        gender
        fullRecord
        referralCode
        usedReferralCode
        membership
        status
        timezone
        expoToken
        platform
        disable
      }
      page
      limit
      totalDocs
      totalPages
    }
  }
`;

export const GET_USER_DETAILS = gql`
  query FindUserByIdAdmin($id: ObjectId!) {
    findUserByIdAdmin(_id: $id) {
      _id
      fullName
      phone
      email
      country
      gender
      status
      createdAt
      membership
      pillars {
        emotions
        purpose
        relations
        selfEsteem
        transformation
      }
    }
  }
`;

export const GET_USER_DETAILS_XLS = gql`
  query ExcelUserList($input: ExcelUserListInput!) {
  excelUserList(input: $input) {
   _id
      fullName
      email
      phone
      phonecode
      country
      gender
      fullRecord
      onboardingStep
      referralCode
      usedReferralCode
      membership
      expiredFreemium
      status
      timezone
      expoToken
      platform
      disable
      streakDate
      claimcredit
      createdAt
      membershipPeriod
      membershipExpired
      pillars {
        emotions
        purpose
        relations
        selfEsteem
        transformation
      }
      roadshistory {
        completed
        name
        activityhistory {
          leadForm {
            id
            form {
              answers
              question
              type
            }
            response
          }
          episode
          activity
        }
        episodes
        episodesCompleted
      }
      emotions {
        points
        tag
        total
      }
    } 
  }
`;

export const USER_PURCHASES_HISTORY = gql`
  query FindUserPurchaseHistoryById($id: ObjectId!) {
    findUserPurchaseHistoryById(_id: $id) {
      _id
      months
      total
    }
  }
`;

export const FIND_EMOTIONS_RECORDS_ADMIN = gql`
  query FindEmotionsRecordAdmin($userId: ObjectId!) {
    findEmotionsRecordAdmin(userId: $userId) {
      points
      tag
      total
    }
  }
`;

export const FEEDBACK_LIST = gql`
  query FeedbackList($search: SearchFeedbackInput!) {
  feedbackList(search: $search) {
    docs {
      _id
      feedback
      user {
        _id
        email
        fullName
      }
      createdAt      
    }
    page
    totalDocs
    totalPages
    limit 
  }
}
`;